import { Schema } from "effect";
import { ResourceWorkspaceId } from "@workerstation/shared/resources/http";
import { ContainerInstance } from "@workerstation/shared/resources/container";
import type { ContainerCatalog, ContainerActionResponse, ContainerInput, ContainerState } from "@workerstation/shared/resources/container";
import { WorkerBindingName } from "@workerstation/shared/resources/worker-binding";

export type ContainerSnapshot = typeof ContainerCatalog.Type;
export type ContainerBinding = ContainerSnapshot["bindings"][number];
export type ContainerResponse = typeof ContainerActionResponse.Type;
export type ContainerCommand = typeof ContainerInput.Type;
export type ContainerStatus = ContainerState;
export const ContainerTarget = Schema.Struct({ workspaceId: Schema.String, revision: Schema.String, bindingName: Schema.String, instance: Schema.String });
export type ContainerTarget = typeof ContainerTarget.Type;
export const PreparedContainerTarget = Schema.Struct({ workspaceId: ResourceWorkspaceId, revision: Schema.String.check(Schema.isMinLength(1)), bindingName: WorkerBindingName, instance: ContainerInstance });
export const containerTargetKey = (target: ContainerTarget): string => JSON.stringify([target.workspaceId, target.revision, target.bindingName, target.instance]);
